import React from 'react';
import { nth, fullNameFromUserId, emailFromUserId } from '../../../common/utils';
import { Icon } from 'semantic-ui-react';
import { CSVLink } from 'react-csv';
import Papa from 'papaparse';
import { map, merge } from 'ramda';
import { generate } from 'shortid';

// https://github.com/react-tools/react-table#columns
export const getColumns = (r) => {
  return [
    nth,
    {
      Header: 'Workshop code',
      accessor: 'competition.code',
      maxWidth: 100,
      Footer: () => {
        const data = [];

        if (r) {
          let parsed = map(w => {
            return merge({
              event: w.event.title,
              code: w.competition.code
            }, w.userData);            
          }, r.getResolvedState().data || []);

          data.push(Papa.unparse(parsed));
        }

        return (
          <div>{map(d => {
            return (
              <CSVLink
                key={generate()}
                data={d}
                filename='workshops'
                className='ui label'>
                <Icon name='download' />csv
              </CSVLink>
            );
          }, data)}</div>
        );
      }
    },
    fullNameFromUserId,
    emailFromUserId,
    {
      Header: 'Participant name',
      accessor: 'family_name',
      maxWidth: 180,
      Cell: ({ original: { userData: u } }) =>  u.family_name + ', ' + u.given_name
    },
    {
      Header: 'Participant email',
      accessor: 'email',
      maxWidth: 180,
      Cell: ({original: { userData: u }}) => u.email
    }
  ];
};

export const DEFAULTSORTED = [
  { id: 'competition.code', desc: true },
  { id: 'userId', desc: true }
];

export const DEFAULTPAGESIZE = 20;



// WEBPACK FOOTER //
// ./src/private/admin/components/Workshops/table.conf.js